import store from '@/store';
import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/agentSubscriptionLanding',
            name: 'network_agentSubscriptionLanding',
            component: () => import("./views/agentSubscriptionLanding.vue"),
        },
        {
            path: '/network/agentSubscription',
            name: 'network_agentSubscription',
            component: () => import("./views/agentSubscription.vue"),
            meta: {
                bottomCutFixed: true,
            },
        },
        {
            path: '/network/agentSubscription/:identifier',
            name: 'network_agentSubscription_detail',
            component: () => import("./views/agentSubscriptionDetail.vue"),
            meta: {
                bottomCutFixed: true,
            }
        },
        {
            path: '/network/agentSubscription/:identifier/sign',
            name: 'network_agentSubscription_detail_sign',
            component: () => import("./views/agentSubscriptionDetailSign.vue"),
            meta: {
            }
        },
        {
            path: '/network/agentSubscriptionRequest',
            name: 'network_agentSubscriptionRequest',
            component: () => import("./views/agentSubscriptionRequest.vue"),
            meta: {
            }
        },

        
    ];
};